import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { IonInput, ModalController } from "@ionic/angular";
import { FormBuilder, Validators } from "@angular/forms";
import { ShareService } from "../services";
import { $e } from "codelyzer/angular/styles/chars";
import { Location } from '@angular/common';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent implements OnInit, AfterViewInit {
  @Input() target;
  @Input() campaign_id;
  @Input() user_id;
  @Input() phoneDefault;
  @Input() isVeryUser;
  step = 1;
  // tslint:disable-next-line:variable-name
  time_retry_otp = 60;
  // tslint:disable-next-line:variable-name
  interval_time;
  form = this.fb.group({
    // phone: ['', [Validators.required, Validators.pattern('[0-9]*'), Validators.maxLength(14), Validators.minLength(9)]],
    phone: ['', [Validators.required, Validators.pattern(new RegExp('(84|0[3|5|7|8|9])+([0-9]{8})\\b'))]],
  });
  formOtp = this.fb.group({
    otp: ['', [Validators.required, Validators.pattern('[0-9]*'), Validators.maxLength(6), Validators.minLength(6)]],
  });
  // tslint:disable-next-line:variable-name
  phone_label;
  phone;
  otp1: any | null;
  otp2: any | null;
  otp3: any | null;
  otp4: any | null;
  otp5: any | null;
  otp6: any | null;
  type: number;
  invaliOtp = true;
  disableButotn = false;
  isSubmit = false;
  
  // Thêm các biến để kiểm tra trạng thái disable của từng ô
  isInput2Disabled = true;
  isInput3Disabled = true;
  isInput4Disabled = true;
  isInput5Disabled = true;
  isInput6Disabled = true;
  @ViewChild('input1', { static: false }) input1Element: IonInput;
  @ViewChild('input2', { static: false }) input2Element: IonInput;
  @ViewChild('input3', { static: false }) input3Element: IonInput;
  @ViewChild('input4', { static: false }) input4Element: IonInput;
  @ViewChild('input5', { static: false }) input5Element: IonInput;
  @ViewChild('input6', { static: false }) input6Element: IonInput;
  constructor(
    private modalController: ModalController,
    private fb: FormBuilder,
    private location: Location,
    private shareService: ShareService,
    private eRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit() {
    this.type = 1; // Set type = 1 để ô đầu tiên có focus
    this.step = 1;
    // this.step = 2;
    if (this.phoneDefault) {
      this.form.get('phone').setValue(this.phoneDefault);
      this.phone = this.phoneDefault;
    }
    
    // Khởi tạo trạng thái disable của các ô
    this.updateInputStates();
  }
  confirmPhone() {
    if (this.form.invalid) {
      // alert('Số điện thoại không hợp lệ!');
      return;
    }
    if (this.isSubmit) { return; }
    this.isSubmit = true;

    const userVery = JSON.parse(localStorage.getItem('userVery'));

    if (userVery?.filter(item => item === this.form.get('phone').value)?.length && this.isVeryUser) {
      this.modalController.dismiss({ isSamePhone: true, phone: this.form.get('phone').value });
      return;
    }
    // const phone  = this.form.controls.phone.value.trim();
    let phone = this.form.controls.phone.value.trim();
    if (phone.split('')[0] !== 0 && phone.length === 9) {
      phone = `0${phone}`;
    }
    this.phone = phone;
    if (!this.phoneDefault) {
      this.location.replaceState(`${this.location.path().split('?')[0]}?phone=${this.phone}`);
    }
    this.shareService.getOtp({
      phone,
      target: this.target,
      user_id: this.user_id
    }).subscribe(
      res => {
        if (res.statusCode === 200) {
          console.log(this.phone);
          const phone = this.form.controls.phone.value.trim();
          const length = phone.length;
          const c = length % 3;
          if (c) {
            const d = phone.slice(0, c);
            const d2 = phone.slice(c, length);
            let d3 = '';
            for (let i = 0; i < d2.length / 3; i++) {
              const p = d2.slice(3 * i, 3 * i + 3);
              d3 = d3 + ' ' + p;
            }
            this.phone_label = d + d3.slice(1, d3.length);
          } else {
            let d = '';
            for (let i = 0; i < length / 3; i++) {
              const p = phone.slice(3 * i, 3 * i + 3);
              d = d + ' ' + p;
            }
            this.phone_label = d.slice(1, d.length);
          }
          if (this.phone.split('')[0] === 0) {
            this.phone_label = '+84 ' + this.phone_label.substring(1, this.phone_label.length);
          } else {
            this.phone_label = '+84 ' + this.phone_label;
          }
                     this.step = 2;
           this.type = 1; // Set type = 1 để ô đầu tiên có focus
           
           // Đảm bảo input được focus và mở bàn phím trên mobile
           setTimeout(() => {
             this.focusFirstInput();
           }, 100);
           
           // Thêm một lần focus nữa sau khi DOM đã render hoàn toàn
           setTimeout(() => {
             this.focusFirstInput();
           }, 800);
          this.setInterval();
          return;
        }
        alert(res.data.message);
      },
      err => {
        alert(err);
      }
    );
  }
  confirmOtp() {
    const otp$ = `${this.otp1}${this.otp2}${this.otp3}${this.otp4}${this.otp5}${this.otp6}`;
    if (otp$.length === 54) {
      return;
    }
    if (otp$.length !== 6 && otp$.length !== 54) {
      return;
    }
    const body = {
      phone: this.phone,
      otp: otp$
    };
    this.disableButotn = true;
    this.shareService.sendOtp(body).subscribe(
      res => {
        console.log(res);
        this.disableButotn = false;
        if (res.statusCode === 200) {

          if (this.isVeryUser) {
            localStorage.setItem('userVery', JSON.stringify([this.form.get('phone').value]));
          }

          localStorage.setItem('otpToken', res.data.token);
          this.modalController.dismiss({ phone: this.phone });
          setTimeout(() => {
            this.shareService.sendOTPDone(true);
          }, 1000);
          return;
        }
        alert(res.data.message);
      },
      err => {
        this.disableButotn = false;
        alert(err);
      }
    );
  }
  closeModal() {
    this.modalController.dismiss();
  }
  retrySendOtp() {
    if (this.time_retry_otp === 0) {
      this.shareService.getOtp({
        phone: this.phone,
        target: this.target,
        user_id: this.user_id
      }).subscribe(
        res => {
          if (res.statusCode === 200) {
            this.time_retry_otp = 60;
            this.interval_time = setInterval(() => {
              this.time_retry_otp = this.time_retry_otp - 1;
              if (this.time_retry_otp === 0) {
                clearInterval(this.interval_time);
              }
            }, 1000);
            return;
          }
          alert(res);
        },
        err => {
          alert(err);
        }
      );
    }
  }
  setInterval() {
    this.time_retry_otp = 60;
    this.interval_time = setInterval(() => {
      this.time_retry_otp = this.time_retry_otp - 1;
      if (this.time_retry_otp === 0) {
        clearInterval(this.interval_time);
      }
    }, 1000);
  }
    // Hàm cập nhật trạng thái disable của các ô
  updateInputStates() {
    // Hàm helper để kiểm tra giá trị có hợp lệ không
    const hasValue = (value: any) => {
      return value !== null && value !== undefined && value !== '';
    };
    
    // Cập nhật trạng thái disable dựa trên việc các ô trước đó có giá trị hay không
    this.isInput2Disabled = !hasValue(this.otp1); // Chỉ enable ô 2 nếu ô 1 có giá trị
    this.isInput3Disabled = !hasValue(this.otp1) || !hasValue(this.otp2); // Chỉ enable ô 3 nếu ô 1 và ô 2 có giá trị
    this.isInput4Disabled = !hasValue(this.otp1) || !hasValue(this.otp2) || !hasValue(this.otp3); // Chỉ enable ô 4 nếu ô 1, 2, 3 có giá trị
    this.isInput5Disabled = !hasValue(this.otp1) || !hasValue(this.otp2) || !hasValue(this.otp3) || !hasValue(this.otp4); // Chỉ enable ô 5 nếu ô 1, 2, 3, 4 có giá trị
    this.isInput6Disabled = !hasValue(this.otp1) || !hasValue(this.otp2) || !hasValue(this.otp3) || !hasValue(this.otp4) || !hasValue(this.otp5); // Chỉ enable ô 6 nếu ô 1, 2, 3, 4, 5 có giá trị
    
    // Debug: Log để kiểm tra
    console.log('updateInputStates called');
    console.log('otp1 value:', this.otp1, 'type:', typeof this.otp1, 'hasValue:', hasValue(this.otp1));
    console.log('isInput2Disabled:', this.isInput2Disabled);
    
    // Force change detection
    this.cdr.detectChanges();
  }

  clickIonItem(type) {
    // Tìm ô cuối cùng có giá trị
    const otpFields = [this.otp1, this.otp2, this.otp3, this.otp4, this.otp5, this.otp6];
    let lastFilledIndex = -1;
    
    // Tìm ô cuối cùng có giá trị
    for (let i = 5; i >= 0; i--) {
      if (otpFields[i] !== null && otpFields[i] !== undefined) {
        lastFilledIndex = i;
        break;
      }
    }
    
    // Chỉ cho phép click vào ô tiếp theo sau ô cuối cùng có giá trị
    const allowedIndex = lastFilledIndex + 1;
    
    if (type - 1 <= lastFilledIndex) {
      // Nếu click vào ô đã có giá trị hoặc ô đứng trước, không cho phép
      // Focus vào ô tiếp theo sau ô cuối cùng có giá trị
      if (allowedIndex < 6) {
        this.type = allowedIndex + 1;
        setTimeout(() => {
          const inputElements = [this.input1Element, this.input2Element, this.input3Element, this.input4Element, this.input5Element, this.input6Element];
          if (inputElements[allowedIndex]) {
            inputElements[allowedIndex].setFocus();
          }
        }, 10);
      } else {
        // Nếu đã nhập đủ 6 ô, focus vào ô cuối cùng
        this.type = 6;
        setTimeout(() => {
          this.input6Element.setFocus();
        }, 10);
      }
    } else {
      // Nếu click vào ô tiếp theo (hợp lệ), focus vào ô đó
      this.type = type;
    }
  }
  onInputEntry(event, nextInput, lastInput?, type?: string) {
    const input = event.target;
    const length = input.value.length;
    const maxLength = input.attributes.maxlength.value;

    // Kiểm tra nếu giá trị là số hợp lệ
    const value = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    const inputValue = Number(input.value);
    
    if (!value.includes(inputValue)) {
      // Nếu không phải số, xóa giá trị
      event.target.value = '';
      this[type] = undefined;
      return;
    }
    
    // Cập nhật giá trị
    this[type] = inputValue;
    
    // Nếu đã nhập đủ 1 ký tự, focus sang ô tiếp theo
    if (length >= Number(maxLength)) {
      event.target.value = inputValue.toString();
      nextInput.setFocus();
    }
    
    // Cập nhật trạng thái disable của các ô với setTimeout để đảm bảo giá trị đã được cập nhật
    setTimeout(() => {
      this.updateInputStates();
      
      // Tự động focus sang ô tiếp theo khi nhập xong
      if (type === 'otp1' && this.otp1 && !this.isInput2Disabled) {
        setTimeout(() => {
          this.input2Element.setFocus();
          this.type = 2;
        }, 50);
      } else if (type === 'otp2' && this.otp2 && !this.isInput3Disabled) {
        setTimeout(() => {
          this.input3Element.setFocus();
          this.type = 3;
        }, 50);
      } else if (type === 'otp3' && this.otp3 && !this.isInput4Disabled) {
        setTimeout(() => {
          this.input4Element.setFocus();
          this.type = 4;
        }, 50);
      } else if (type === 'otp4' && this.otp4 && !this.isInput5Disabled) {
        setTimeout(() => {
          this.input5Element.setFocus();
          this.type = 5;
        }, 50);
      } else if (type === 'otp5' && this.otp5 && !this.isInput6Disabled) {
        setTimeout(() => {
          this.input6Element.setFocus();
          this.type = 6;
        }, 50);
      }
    }, 0);
    
    // Kiểm tra xem tất cả 6 ô đã có giá trị chưa
    const hasValue = (value: any) => {
      return value !== null && value !== undefined && value !== '';
    };
    
    this.invaliOtp = !hasValue(this.otp1) || !hasValue(this.otp2) || !hasValue(this.otp3) || 
                     !hasValue(this.otp4) || !hasValue(this.otp5) || !hasValue(this.otp6);
    
    // Debug: Log để kiểm tra
    console.log('OTP Values:', {
      otp1: this.otp1,
      otp2: this.otp2,
      otp3: this.otp3,
      otp4: this.otp4,
      otp5: this.otp5,
      otp6: this.otp6
    });
    console.log('Disabled States:', {
      input2: this.isInput2Disabled,
      input3: this.isInput3Disabled,
      input4: this.isInput4Disabled,
      input5: this.isInput5Disabled,
      input6: this.isInput6Disabled
    });
    console.log('invaliOtp:', this.invaliOtp);
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      this.type = undefined;
    }
  }
  onKeydown($event, value, lastInput, t, nextInput) {
    if ($event.key === 'Backspace') {
      // Ngăn chặn hành vi mặc định
      $event.preventDefault();
      
      // Xác định vị trí hiện tại
      const currentIndex = parseInt(value.replace('otp', '')) - 1;
      
      // Xóa giá trị ở ô hiện tại
      const fieldName = `otp${currentIndex + 1}`;
      this[fieldName] = undefined;
      
      // Xóa giá trị hiển thị trong input hiện tại
      $event.target.value = '';
      
      // Cập nhật trạng thái disable của các ô
      this.updateInputStates();
      
      // Focus vào ô trước đó hoặc ô đầu tiên nếu đang ở ô đầu
      setTimeout(() => {
        if (currentIndex > 0) {
          lastInput.setFocus();
          this.type = t;
        } else {
          // Nếu đang ở ô đầu tiên, focus vào ô đầu
          this.input1Element.setFocus();
          this.type = 1;
        }
      }, 10);
    } else {
      if ($event.target.value) {
        nextInput.setFocus();
      }
    }
  }
     // Phương thức để focus vào ô đầu tiên và mở bàn phím
   focusFirstInput() {
     if (this.input1Element) {
       // Force change detection trước khi focus
       this.cdr.detectChanges();
       
       // Focus lần đầu
       this.input1Element.setFocus();
       
       // Click vào input để đảm bảo bàn phím mở trên mobile
       setTimeout(() => {
         this.input1Element.getInputElement().then(inputElement => {
           if (inputElement) {
             inputElement.click();
           }
         });
         this.input1Element.setFocus();
       }, 50);
       
       // Focus lần thứ hai để đảm bảo bàn phím mở trên mobile
       setTimeout(() => {
         this.input1Element.setFocus();
       }, 150);
       
       // Focus lần thứ ba để đảm bảo bàn phím mở
       setTimeout(() => {
         this.input1Element.setFocus();
       }, 300);
       
       // Focus lần thứ tư để đảm bảo bàn phím mở trên một số thiết bị
       setTimeout(() => {
         this.input1Element.setFocus();
       }, 500);
       
       // Focus lần thứ năm để đảm bảo bàn phím mở
       setTimeout(() => {
         this.input1Element.setFocus();
       }, 800);
     }
   }

   ngAfterViewInit() {
     // Nếu đang ở step 2, focus vào input đầu tiên
     if (this.step === 2) {
       setTimeout(() => {
         this.focusFirstInput();
       }, 100);
     }
   }
}
